<template>
  <div class="validation-container">
    <div class="validation-card shadow border border-secondary-subtle">
      <i class="bi bi-x-circle-fill text-danger d-block mb-3" style="font-size: 3.5rem;"></i>
      <h2 class="text-danger fw-bold mb-3">Falha na Validação</h2>
      <p class="text-body-secondary mb-4">O seu link de validação é inválido ou já expirou. Por favor, tente fazer o login para solicitar um novo link.</p>
      <router-link to="/" class="btn btn-secondary w-100 btn-lg">Voltar para o Login</router-link>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'ValidacaoFalhou'
})
</script>

<style scoped>
/* GUARDIÃO: Variáveis CSS do Bootstrap 5 para suportar Dark Mode automaticamente */
.validation-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: var(--bs-tertiary-bg);
  transition: background-color 0.3s ease;
}

.validation-card {
  text-align: center;
  width: 100%;
  max-width: 450px;
  padding: 3rem 2.5rem;
  background-color: var(--bs-body-bg);
  color: var(--bs-body-color);
  border-radius: 0.5rem;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  transition: background-color 0.3s ease, border-color 0.3s ease;
}
</style>
